export const products = {
  pomoTimer: {
    priceId: 'price_1RDDPbPqwrkGjLzqQdF6nBMf',
    name: 'PomoTimer',
    description: 'Unlock premium features and support our development.',
    mode: 'payment' as const,
  },
} as const;